export const kybNegativeCertificateChecks = {
  BR: {
    BUSINESS: [
      {
        title: 'cnjNegativeCertificate',
        subtitle: 'cnjNegativeCertificate',
        items: [
          {
            name: 'cnjJuridico',
            key: 'CNJ_JURIDICO',
            title: 'cnjJuridico',
          },
        ],
      },
    ],
    PERSON: [
      {
        title: 'cnjNegativeCertificate',
        subtitle: 'cnjNegativeCertificate',
        items: [
          {
            name: 'cnjFisico',
            key: 'CNJ_FISICO',
            title: 'cnjFisico',
          },
          {
            name: 'antecedentesPf',
            key: 'ANTECEDENTES_PF',
            title: 'antecedentesPf',
          },
        ],
      },
    ],
  },
  AR: {
    BUSINESS: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
    PERSON: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
  },
  CR: {
    BUSINESS: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
    PERSON: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
  },
  CO: {
    BUSINESS: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
    PERSON: [
      {
        title: 'noCertificatesEnableForThisCountry',
        subtitle: 'noCertificatesEnableForThisCountry',
        items: [],
      },
    ],
  },
}
